import clsx from 'clsx';
import CopyButton from 'components/atoms/CopyButton/CopyButton';
import { kebabCase } from 'lodash';
import React from 'react';
import styles from './InfoItem.module.scss';

export type InfoItemProps = {
  label: string;
  value: React.ReactNode;
  valueNote?: string;
  hasCopyButton?: boolean;
  hasCopyButtonTooltip?: string;
  maxWidth?: string;
  className?: string;
};

const InfoItem = ({
  label,
  value,
  hasCopyButton,
  valueNote,
  maxWidth,
  className,
}: InfoItemProps) => {
  const dataTestId = `project-info-item__${kebabCase(label)}`;

  return (
    <div className={clsx(styles.container, className)}>
      <p className={styles.label}>{label}</p>

      <div className={styles.value} data-testid={dataTestId}>
        <div
          className={clsx(styles.valueContent, maxWidth && styles.truncate)}
          style={{ maxWidth: maxWidth ? maxWidth : '100%' }}
        >
          {value}
          {hasCopyButton && typeof value === 'string' && (
            <CopyButton textToCopy={value} className={styles.copyButton} />
          )}
        </div>
        {valueNote && <div className={styles.valueNote}>{valueNote}</div>}
      </div>
    </div>
  );
};

export { InfoItem };
